<template>
  <section class="bg-base py-20 px-6 md:px-20">
    <h2 class="text-3xl md:text-3xl font-bold text-center mb-10 text-primary">
      Conoce nuestros seguros personales
    </h2>

    <Splide
      :options="splideOptions"
      aria-label="Seguros"
      class="seguros-carrusel max-w-[95vw] xl:max-w-[1280px] mx-auto"
    >
      <SplideSlide
        v-for="(seguro, index) in seguros"
        :key="index"
        class="slide pt-4 pb-6"
      >
        <router-link
          :to="
            '/' +
            seguro.nombre
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/ /g, '-')
          "
          class="group transition-all duration-300 ease-in-out cursor-pointer rounded-xl shadow-md bg-white w-44 sm:w-48 xl:w-52 h-64 sm:h-72 xl:h-[19rem] mx-auto overflow-hidden flex flex-col"
        >
          <!-- Título en la parte superior con espacio mínimo -->
          <div class="pt-3 px-2 pb-2">
            <h3
              class="text-sm sm:text-base xl:text-lg font-semibold text-[#212121] text-center group-hover:underline no-fade"
            >
              {{ seguro.nombre }}
            </h3>
          </div>

          <!-- Imagen ocupa todo el resto sin cortar -->
          <div class="flex-1 w-full">
            <img
              :src="`/seguros/${seguro.img}`"
              :alt="seguro.nombre"
              class="h-full w-full object-cover"
            />
          </div>
        </router-link>
      </SplideSlide>
    </Splide>
  </section>
</template>

<script setup>
import "@splidejs/vue-splide/css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";

const seguros = [
  { nombre: "Gastos médicos", img: "C-Gastos.png" },
  { nombre: "Vida", img: "C-Vida.png" },
  { nombre: "Accidentes", img: "C-Accidentes.png" },
  { nombre: "Auto", img: "C-Auto.png" },
  { nombre: "Hogar", img: "C-Hogar.png" },
  { nombre: "Viajes", img: "C-Viajes.png" },
  { nombre: "Ahorro", img: "C-Ahorro.png" },
  { nombre: "Mascotas", img: "C-Mascotas.png" },
];

const splideOptions = {
  type: "loop",
  perPage: 5,
  focus: 2,
  trimSpace: false,
  autoplay: true,
  interval: 4000,
  pauseOnHover: true,
  pagination: false,
  arrows: false,
  gap: "1rem",
  breakpoints: {
    1280: { perPage: 5, focus: 2 },
    1024: { perPage: 3, focus: 1 },
    768: { perPage: 2, focus: 1 },
    480: { perPage: 1, focus: 0 },
  },
};
</script>

<style scoped>
.seguros-carrusel :deep(.splide__slide) {
  transition: transform 0.3s ease;
}

.seguros-carrusel :deep(.splide__slide .group) {
  transform: scale(0.95);
  transition: transform 0.3s ease;
  opacity: 1; /* ✅ Mantiene color constante */
}

.seguros-carrusel :deep(.splide__slide.is-prev .group),
.seguros-carrusel :deep(.splide__slide.is-next .group) {
  transform: scale(1);
}

.seguros-carrusel :deep(.splide__slide.is-active .group) {
  transform: scale(1.09);
  z-index: 10;
}

/* ✅ Mantiene el color del texto firme siempre */
.no-fade {
  color: #101541 !important;
  opacity: 1 !important;
}
</style>
